import { useMemo } from 'react';
import clx from 'classnames';
import { ImageWithDefault } from '@web3/components';

import styles from './index.module.scss';

const DEFAULT_TOKEN_SIZE = new Map([
  ['default', 28],
  ['small', 18],
  ['large', 44],
]);

const DEFAULT_CHAIN_SIZE = new Map([
  ['default', 12],
  ['small', 10],
  ['large', 20],
]);

interface TokenIconProps {
  className?: string;
  size?: 'default' | 'small' | 'large';
  tokenSrc?: string;
  chainSrc?: string;
  tokenSize?: number;
  chainSize?: number;
}

export const TokenIcon = (props: TokenIconProps) => {
  const { className, tokenSrc = '', chainSrc = '', size = 'default', tokenSize = '', chainSize = '' } = props;

  const tokenStyle = useMemo(() => {
    return {
      width: tokenSize || DEFAULT_TOKEN_SIZE.get(size),
      height: tokenSize || DEFAULT_TOKEN_SIZE.get(size),
    };
  }, [size, tokenSize]);

  const chainStyle = useMemo(() => {
    return {
      width: chainSize || DEFAULT_CHAIN_SIZE.get(size),
      height: chainSize || DEFAULT_CHAIN_SIZE.get(size),
    };
  }, [chainSize, size]);

  return (
    <div
      className={clx(styles.token, styles[size], className, {
        [styles.empty]: !tokenSrc,
      })}
      style={tokenStyle}
    >
      <ImageWithDefault
        src={tokenSrc}
        alt="token"
        width={tokenStyle.width}
        height={tokenStyle.height}
        resize={{
          width: tokenStyle.width,
          height: tokenStyle.height,
        }}
        className={styles.tokenImg}
      />
      {chainSrc && (
        <ImageWithDefault
          src={chainSrc}
          alt="chain"
          width={chainStyle.width}
          height={chainStyle.height}
          resize={{
            width: chainStyle.width,
            height: chainStyle.height,
          }}
          className={styles.chainImg}
        />
      )}
    </div>
  );
};
